import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../ui/Button';

const SubmissionPageHeader = ({ id, isDark, title, description }) => {
    const navigate = useNavigate();

    return (
        <div className='flex flex-col sm:flex-row items-start gap-[16px] sm:gap-[30px] sm:justify-between'>
            <div className='flex-1 flex flex-col gap-[6px]'>
                <div className='flex items-center gap-[6px]'>
                    <button type='button' onClick={() => navigate('/submission?cleardata=false')} className='p-0 m-0 border-0 bg-transparent cursor-pointer'>
                        <ArrowLeft size={20} className={`transition-colors duration-200 ${isDark ? 'text-white' : 'text-[#072837]'}`} />
                    </button>
                    <h1 className={`m-0 font-semibold text-[18px] sm:text-[20px] transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>{title}</h1>
                </div>
                <p className={`m-0 font-normal text-[14px] sm:text-[16px] transition-colors duration-200 ${
                    isDark ? 'text-[#b0b0b0]' : 'text-[#686868]'
                }`}>{description}</p>
            </div>

            <Button
              variant="orange"
              isDark={isDark}
              onClick={() => navigate(`/submissions/${id}`)}
              className='px-3 py-2.5'
              icon={
                <div
                  className="w-[16px] h-[16px]"
                  style={{
                    backgroundColor: isDark ? '#000000' : '#ffffff',
                    WebkitMaskImage: "url('/assets/icons/viewdata.svg')",
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskSize: 'contain',
                    WebkitMaskPosition: 'center',
                    maskImage: "url('/assets/icons/viewdata.svg')",
                    maskRepeat: 'no-repeat',
                    maskSize: 'contain',
                    maskPosition: 'center',
                    transition: 'background-color 0.2s ease'
                  }}
                  aria-hidden="true"
                />
              }
            >
              View Submission
            </Button>
        </div>
    );
};

export default SubmissionPageHeader;
